import BaseApi from './BaseApi';

class DoctorSchedulesApi extends BaseApi {
  public createSchedule(payload: any) {
    return this.post('/', payload);
  }

  protected getSpecificApiPrefix(): string {
    return 'managers/doctor-schedules';
  }
}

export default DoctorSchedulesApi;
